// This icon file is generated automatically.
var CircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1027 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M511.62 52.54a459.2 459.2 0 10-.07 918.4 459.2 459.2 0 00.07-918.33zm0 833.48a374.27 374.27 0 110-748.48 374.27 374.27 0 010 748.48z" } }] }, "name": "circle", "theme": "outlined" };
export default CircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CircleOutlined.js
// module id = 2225
// module chunks = 0